import { React, useState } from 'react'
import { Link } from 'react-router-dom';
import AdminHeader from './AdminHeader';
import Sidebar from './Sidebar';


const AddInvestment = () => {

  const [isOpen, setOpen] = useState(false);
  // const [isClose, setClose] = useState(false);
  const toggleOpen = () => {
    setOpen(!isOpen);
  };
  return (
    <>
      <div className="dashboard">
        <div className={isOpen ? 'd-flex toggled' : 'd-flex'} id="wrapper">
          <Sidebar />
          <div className="page-content">
            <nav className="navbar navbar-expand-lg navbar-light bg-transparent">
              <div className="d-flex align-items-center py-3 ps-3 d-lg-none">
                <Link onClick={toggleOpen} role="button"><i className="fas  fa-align-left primary-text fs-4 me-3" id="menu-toggle"></i></Link>

              </div>
              <AdminHeader />
            </nav>
            {/* <!-- Areas --> */}
            <div className="dashboard-page p-4">
              {/* contact form starts*/}
              <div className="contact dashboard-form">
                <div className="container">


                  <div className="contact-area cont-bx">
                    <form action="">
                      <div className="row">

                        <div className="col-lg-6 mb-5 mb-lg-0">

                          <div className="contact-form">

                            <div className="mb-4">
                              <label>Name</label>
                              <input type="text" placeholder="Enter name" />
                            </div>
                       
                            <div className="mb-4">
                              <label>Required Fund</label>
                              <input type="text" placeholder="Enter Required fund" />
                            </div>
                            <div className="mb-4">
                              <label>Estimated Appreciation</label>
                              <input type="text" placeholder="Enter Estimated Appreciation in %" />
                            </div>
                            <div className="mb-4">
                              <label>Terms &amp; consitions</label>
                              <div class="form-check d-flex">
                                <input type="checkbox" value="" />
                                <label class="form-check-label" for="flexCheckDefault">
                                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Alias dolorum amet corporis tenetur deleniti necessitatibus? At magnam commodi, eos non iste in soluta, porro odit ad labore, nihil maiores suscipit
                                </label>
                              </div>
                              <div class="form-check d-flex">
                                <input type="checkbox" value="" checked />
                                <label for="flexCheckChecked">
                                  Checked checkbox
                                </label>
                              </div>
                              <div class="form-check d-flex">
                                <input type="checkbox" value="" checked />
                                <label for="flexCheckChecked">
                                  Checked checkbox
                                </label>
                              </div>
                              <div class="form-check d-flex">
                                <input type="checkbox" value="" checked />
                                <label for="flexCheckChecked">
                                  Checked checkbox
                                </label>
                              </div>
                              <div class="form-check d-flex">
                                <input type="checkbox" value="" checked />
                                <label for="flexCheckChecked">
                                  Checked checkbox
                                </label>
                              </div>
                            </div>

                            {/* <div className="send-button">
                              <button>Send</button>
                            </div> */}

                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="contact-form">

                            <div className="mb-4">
                              <label>Extent</label>
                              <input type="text" placeholder="Enter Extent" />
                            </div>
                            <div className="mb-4">
                              <label>Duration</label>
                              <input type="text" placeholder="12 months, 24 months, 36 months, custom" />
                            </div>
                            <div className="mb-4">
                              <label>Lock in Period</label>
                              <input type="text" placeholder="Enter Period" />
                            </div>

                       

                            {/* <div className="send-button">
  <button>Send</button>
</div> */}

                          </div>
                        </div>

                      </div>
                      <div className="next-button text-end">
                        <button>Save</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              {/* contact form ends */}
            </div>
          </div>
        </div>
      </div>


    </>
  )
}

export default AddInvestment